
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions-and-events/exhibition/[slug]",
      function () {
        return require("private-next-pages/exhibitions-and-events/exhibition/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions-and-events/exhibition/[slug]"])
      });
    }
  